import { isObjectEmpty, log } from "../../services/Utils";

const ConfirmationAlert = (settings) => {
    let id = isObjectEmpty(settings, 'id') ? 'confirm-modal' : settings["id"];
    let type = isObjectEmpty(settings, 'type') ? "warning" : settings["type"];
    let title = isObjectEmpty(settings, 'title') ? "Are you sure?" : settings['title'];
    let oKTitle = isObjectEmpty(settings, 'oKTitle') ? "Ok" : settings['oKTitle'];
    let cancelTitle = isObjectEmpty(settings, 'cancelTitle') ? "Cancel" : settings['cancelTitle'];
    let message = isObjectEmpty(settings, 'message') ? "If you are sure, kindly proceed..." : settings["message"];
    let action = isObjectEmpty(settings, 'action') ? () => { } : settings['action'];
    //const ConfirmAction = ({ id = "confirmation-modal", type = "danger", cancelTitle = "Cancel", oKTitle = "Ok", title = "Are you sure?", message = "", action=()=>{} }) => {
    if (settings['id'] == 'confirm-modal')
        return (<div></div>);
    else
        return (
            <div>
                <div class="modal modal-blur fade" id="confirm" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class={"modal-status bg-" + type}></div>
                            <div class="modal-body text-center py-4">
                                <i class={"fa fa-3x fa-warning text-" + type}></i>
                                <h3>{title}</h3>
                                <div class="text-muted">{message}</div>
                            </div>
                            <div class="modal-footer">
                                <div class="w-100">
                                    <div class="row">
                                        <div class="col"><a href="#" class="btn w-100" data-bs-dismiss="modal">
                                            {cancelTitle}
                                        </a></div>
                                        <div class="col"><a href="#" class={"btn w-100 btn-" + type} data-bs-dismiss="modal"
                                            onClick={action}
                                        >
                                            {oKTitle}
                                        </a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
};
export {
    ConfirmationAlert
}